module.exports = __webpack_public_path__ + "img/1_1-parcheggio-0.12a2325e.png";